module.exports = __webpack_public_path__ + "img/ico_camera.8ed3c313.svg";